import React from 'react';
import { Modal, Content, ContainerCollapsibleActivityTracker, ContentCollapsibleActivityTracker } from './styled';
import { IoIosCloseCircle, IoMdCheckmarkCircle } from 'react-icons/io';
import { Button, Collapsible, CollapsibleItem } from 'react-materialize';

export function ActivityTracker({ data, onChange, onClose }) {
  return (
    <Modal>
      <Content>
        <div className="activityTrackerBtnc" style={{ display: 'flex', justifyContent: 'flex-end', width: '100%' }}>
          <button onClick={onClose}>
            Fechar <IoIosCloseCircle size={20} />
          </button>
        </div>
        <section>
          {data.map((item) => (
            <ContainerCollapsibleActivityTracker key={item.PRCH_ID}>
              <ContentCollapsibleActivityTracker>
                <Collapsible accordion>
                  <CollapsibleItem
                    className="collapsibleQuestionManagerItem"
                    expanded={false}
                    icon={
                      <>
                        <p className="material-icons plus">add_circle_outline</p>

                        <p className="material-icons minus">remove_circle_outline</p>
                      </>
                    }
                    header={
                      <div
                        style={{
                          display: 'flex',
                          flexDirection: 'column',
                          width: '100%',
                          padding: '5px',
                          gap: '5px',
                          background: '#8e44ad',
                          color: '#fff',
                          borderRadius: '5px',
                        }}
                      >
                        <span style={{ fontWeight: '700' }}>
                          {item.PRCH_CODIGO} -{' '}
                          <strong style={{ fontWeight: '500' }}>
                            {item.PRCH_LOTE} / {item.PRCH_DOC_SERIE}
                          </strong>
                        </span>
                      </div>
                    }
                    node="div"
                  >
                    <div>
                      <p>
                        <strong style={{ fontWeight: '700' }}>Cód:</strong> {item.PRCH_CODIGO}
                      </p>
                      <p>
                        <strong style={{ fontWeight: '700' }}>Produto:</strong> {item.PROD_DESCR}
                      </p>
                      <p>
                        <strong style={{ fontWeight: '700' }}>Cliente:</strong> {item.CLI_NOME_FANTASIA}
                      </p>
                      <p>
                        <strong style={{ fontWeight: '700' }}>Lote:</strong> {item.PRCH_LOTE}
                      </p>
                      <p>
                        <strong style={{ fontWeight: '700' }}>Série:</strong> {item.PRCH_DOC_SERIE}
                      </p>
                      <p>
                        <strong style={{ fontWeight: '700' }}>Obs:</strong> {item.PRCH_OBS}
                      </p>
                      <p>
                        <strong style={{ fontWeight: '700' }}>Doc:</strong> {item.PRCH_DOC}
                      </p>
                      <Button
                        className="waves-effect waves-light saib-button is-primary"
                        style={{ width: '100%', marginTop: '0.2rem' }}
                        onClick={() => onChange(item)}
                      >
                        Selecionar{' '}
                        <i>
                          <IoMdCheckmarkCircle size={20} />
                        </i>
                      </Button>
                    </div>
                  </CollapsibleItem>
                </Collapsible>
              </ContentCollapsibleActivityTracker>
            </ContainerCollapsibleActivityTracker>
          ))}
        </section>
      </Content>
    </Modal>
  );
}
